import type { ReactNode } from 'react'
import { Suspense } from 'react'
import { LoadErrorBoundary } from './LoadErrorBoundary'
import { PageLoadingSpinner } from './LoadingSpinner'

export const LoadPage = (p: { readonly children?: ReactNode }) => (
	<LoadErrorBoundary>
		<Suspense fallback={<PageLoadingSpinner />}>{p.children}</Suspense>
	</LoadErrorBoundary>
)
